// Texte de gravure/impression LIGNE PAR LIGNE (demande du propriétaire
// 2026-10-10) : « Ligne 1 : … », « Ligne 2 : … » — lisible d'un coup d'œil pour
// l'atelier dans les soumissions et les ventes. Une ligne saisie = une ligne gravée.

export function lignesGravure(texte) {
  return String(texte || "").split(/\r?\n/).map((x) => x.trim()).filter(Boolean);
}

// Extrait le texte de gravure d'une ligne de soumission : champ structuré
// (inscription_text — boutique) ou segment « Texte — … » / « Texte : … » du
// détail (formulaires), ou le détail multi-lignes saisi par l'admin.
export function extraitTexteGravure(it) {
  if (String(it?.inscription_text || "").trim()) return it.inscription_text;
  const d = String(it?.details || "");
  const m = d.match(/Texte\s+—\s+([\s\S]+?)(?:\s+—\s+(?:Notes?|Couleur|Color|Gravure\/impression)[\s\S]*$|$)/);
  if (m) return m[1].split(" / ").map((x) => x.replace(/^Ligne\s*\d+\s*:\s*/i, "")).join("\n");
  const m2 = d.match(/Texte\s*:\s*([\s\S]+?)(?:\s+—\s+(?:Notes?|Couleur|Color|Gravure\/impression)[\s\S]*$|$)/);
  if (m2) return m2[1];
  return /\n/.test(d) ? d : "";
}

export default function GravureLignes({ texte, testid = "gravure-lignes" }) {
  const lignes = lignesGravure(texte);
  if (!lignes.length) return null;
  return (
    <span className="block mt-1 space-y-0.5" data-testid={testid}>
      {lignes.map((l, i) => (
        <span key={i} className="block text-xs" data-testid={`${testid}-ligne-${i + 1}`}>
          <span className="text-gold/80 font-semibold">Ligne {i + 1} :</span>{" "}
          <strong className="text-ivory">{l}</strong>
        </span>
      ))}
    </span>
  );
}
